import { render, staticRenderFns } from "./BadgeColumn.vue?vue&type=template&id=30860721&scoped=true"
import script from "./BadgeColumn.vue?vue&type=script&lang=js"
export * from "./BadgeColumn.vue?vue&type=script&lang=js"
import style0 from "./BadgeColumn.vue?vue&type=style&index=0&id=30860721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30860721",
  null
  
)

export default component.exports